import type { TOC } from '@ember/component/template-only';
import { PrismModal, PrismTable } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import GeneralButtonsButtonExport from 'lumen/components/general/buttons/button-export';
import type MarketRevenueInsightCurrencyTableController from 'lumen/controllers/market/revenue-insight/currency-table';

interface MarketRevenueInsightCurrencyTableSignature {
  Args: {
    controller: MarketRevenueInsightCurrencyTableController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.multi.redirectOnClose}}
    @title={{t "general.currency"}}
  >
    <:actions>
      <GeneralButtonsButtonExport
        @exportAction={{@controller.exportCurrencyTable}}
        @isDisabled={{@controller.isLoading}}
        data-event-id="market-revenue-insight-export-currency-table"
      />
    </:actions>
    <:default>
      <div class="modal--small">
        <PrismTable
          {{! @glint-expect-error: Incorrect type }}
          @columns={{@controller.columns}}
          @isLoading={{@controller.isLoading}}
          @nrOfEmptyRows={{5}}
          @nrOfLoadingRows={{5}}
          @removeTableBorder={{true}}
          @rows={{@controller.rows}}
        />
      </div>
    </:default>
  </PrismModal>
</template> satisfies TOC<MarketRevenueInsightCurrencyTableSignature>;
